import { render, staticRenderFns } from "./FortumoComponent.vue?vue&type=template&id=b70610e0&"
import script from "./FortumoComponent.vue?vue&type=script&lang=js&"
export * from "./FortumoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports